/**
 * Eine Aufzählung mitten im Absatz wird eine Liste. (24.09.2026)
 *
 * Martin, mit Bild einer Meldung „Tickets durchsehen“: *„Solche Texte bitte
 * schöner formatieren. Sie sind sehr schwer zu lesen.“* Im Bild stand ein
 * einziger Absatz: „Drei Punkte für Martin — 1) … 2) … 3) …“, jeder Punkt
 * zwei Zeilen lang, ohne Umbruch.
 *
 * Die Quelle ist korrigiert (der Auftrag geplanter Läufe verlangt jetzt je
 * Punkt eine Zeile). Das hier fängt alle anderen Wege und alle alten Texte:
 * renderMarkdown macht aus „1) … 2) … 3) …“ in EINEM Absatz eine Liste.
 *
 * ⚠️ Nur bei einer echten Aufzählung: mindestens zwei Punkte, fortlaufend
 *    ab 1 nummeriert, jeder mit Inhalt. „Punkt 1) war gut“ oder eine einzelne
 *    „3)“ in Fließtext bleiben, wie sie sind.
 * ⚠️ Nur „1)“ und „(1)“ — nicht „1.“: das steht in Daten („24.09.“) und
 *    Versionen und würde Sätze zerreißen.
 */

export interface Aufzaehlung {
  /** Was vor „1)“ steht, ohne abschließendes Gedankenstrich/Doppelpunkt. */
  einleitung: string;
  punkte: string[];
}

/** Marke „1)“ bzw. „(1)“ am Anfang oder nach Leerraum/Strich/Doppelpunkt. */
const MARKE = /(^|[\s:—–-])\(?([1-9])\)\s+/g;

export function inlineAufzaehlung(text: string): Aufzaehlung | null {
  if (text.includes("\n")) return null; // nur einzeilige Absätze
  const treffer: { nr: number; start: number; inhalt: number }[] = [];
  MARKE.lastIndex = 0;
  for (let m = MARKE.exec(text); m; m = MARKE.exec(text)) {
    const nr = Number(m[2]);
    // Fortlaufend: die nächste erwartete Nummer, sonst ist es keine Aufzählung.
    if (nr !== treffer.length + 1) continue;
    const start = m.index + (m[1] ?? "").length;
    treffer.push({ nr, start, inhalt: m.index + m[0].length });
  }
  if (treffer.length < 2) return null;
  const punkte: string[] = [];
  for (let i = 0; i < treffer.length; i++) {
    const t = treffer[i];
    const ende = i + 1 < treffer.length ? (treffer[i + 1]).start : text.length;
    const punkt = text.slice(t.inhalt, ende).trim().replace(/[;,]\s*$/, "").trim();
    if (punkt.length < 3) return null;
    punkte.push(punkt);
  }
  const einleitung = text
    .slice(0, (treffer[0]).start)
    .trim()
    .replace(/\s*[—–:-]\s*$/, "")
    .trim();
  return { einleitung, punkte };
}
